<template>
    <div class="block">
        <div>

        </div>
        <van-grid>
            <swipe-image/>
        </van-grid>
        <van-grid class="gridwarp" clickable :column-num="2"  icon-size="44" >
            <!--<van-grid-item class="item"  to="/Home/PickupCodeTh">-->
                <!--<div style="width:100% ;-webkit-box-orient: horizontal; -webkit-box-direction: normal;-webkit-flex-direction: row;flex-direction: row;padding-top:20px">-->
                    <!--<div style="width:45%;float:left;text-align: center">-->
                        <!--<van-icon name="scan" :color="iconclor" size="35px"/>-->
                    <!--</div>-->
                    <!--<div style="width:55%;float:right;font-size: 16px;text-align: left;padding-top:8px">-->
                        <!--我的预约-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<p class="subtitle" style="font-size: 14px">提送货预约</p>-->
                <!--</div>-->
            <!--</van-grid-item>-->

            <!--<van-grid-item class="item"  to="/Home/LadingBillTh">-->
<!--                <div style="width:100% ;-webkit-box-orient: horizontal; -webkit-box-direction: normal;-webkit-flex-direction: row;flex-direction: row;padding-top:20px">-->
<!--                    <div style="width:45%;float:left;text-align: center">-->
<!--                        <van-icon name="send-gift-o" :color="iconclor" size="35px"/>-->
<!--                    </div>-->
<!--                    <div style="width:55%;float:right;font-size: 16px;text-align: left;padding-top:8px">-->
<!--                        提单查询-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div>-->
<!--                    <p class="subtitle" style="font-size: 14px">货主提单信息</p>-->
<!--                </div>-->
            <!--</van-grid-item>-->

            <van-grid-item class="item"   to="/Home/MyOutTh">
                <div style="width:100% ;-webkit-box-orient: horizontal; -webkit-box-direction: normal;-webkit-flex-direction: row;flex-direction: row;padding-top:20px">
                    <div style="width:45%;float:left;text-align: center">
                        <van-icon name="todo-list-o" :color="iconclor" size="35px"/>
                    </div>
                    <div style="width:55%;float:right;font-size: 16px;text-align: left;padding-top:8px">
                        我的提单
                    </div>
                </div>
                <div>
                    <p class="subtitle" style="font-size: 14px">提单到达、出库信息</p>
                </div>
            </van-grid-item>

            <van-grid-item class="item"   to="/Home/OutnotifySel">
                <div style="width:100% ;-webkit-box-orient: horizontal; -webkit-box-direction: normal;-webkit-flex-direction: row;flex-direction: row;padding-top:20px">
                    <div style="width:45%;float:left;text-align: center">
                        <van-icon name="logistics" :color="iconclor" size="35px"/>
                    </div>
                    <div style="width:55%;float:right;font-size: 16px;text-align: left;padding-top:8px">
                        送货单查询
                    </div>
                </div>
                <div>
                    <p class="subtitle" style="font-size: 14px">送货单明细</p>
                </div>
            </van-grid-item>

<!--            <van-grid-item class="item" to="/Home/FleetTh">-->
<!--                <div style="width:100% ;-webkit-box-orient: horizontal; -webkit-box-direction: normal;-webkit-flex-direction: row;flex-direction: row;padding-top:20px">-->
<!--                    <div style="width:45%;float:left;text-align: center">-->
<!--                        <van-icon name="logistics" :color="iconclor" size="35px"/>-->
<!--                    </div>-->
<!--                    <div style="width:55%;float:right;font-size: 16px;text-align: left;padding-top:8px">-->
<!--                        我的车辆-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div>-->
<!--                    <p class="subtitle" style="font-size: 14px">进车辆、驾驶员信息</p>-->
<!--                </div>-->
<!--            </van-grid-item>-->

<!--            <van-grid-item class="item"  to="/Home/PickupCode">-->
<!--                <div class="iconwarp">-->
<!--                    <van-icon name="scan" :color="iconclor" size="35px"/>-->
<!--                </div>-->
<!--                <div class="textwarp">-->
<!--                    提货码-->
<!--                    <p class="subtitle">进出场、提货时出示</p>-->
<!--                </div>-->
<!--            </van-grid-item>-->
<!--            <van-grid-item class="item"  to="/Home/LadingBill">-->
<!--                <div class="iconwarp">-->
<!--                    <van-icon name="send-gift-o" :color="iconclor" size="35px"/>-->
<!--                </div>-->
<!--                <div class="textwarp">-->
<!--                    提单查询-->
<!--                    <p class="subtitle">货主提单信息</p>-->
<!--                </div>-->
<!--            </van-grid-item>-->
<!--            <van-grid-item class="item"  to="/Home/MyOut">-->
<!--                <div class="iconwarp">-->
<!--                    <van-icon name="todo-list-o" :color="iconclor" size="35px"/>-->
<!--                </div>-->
<!--                <div class="textwarp">-->
<!--                    提货配车-->
<!--                    <p class="subtitle">提单分配、出库信息</p>-->
<!--                </div>-->
<!--            </van-grid-item>-->
<!--            <van-grid-item class="item"  to="/Home/Fleet">-->
<!--                <div class="iconwarp">-->
<!--                    <van-icon name="logistics" :color="iconclor" size="35px"/>-->
<!--                </div>-->
<!--                <div class="textwarp">-->
<!--                    我的车辆-->
<!--                    <p class="subtitle">进车辆、驾驶员信息</p>-->
<!--                </div>-->
<!--            </van-grid-item>-->

        </van-grid>
    </div>
</template>

<script>
    import SwipeImage from "../components/SwipeImage";
    import { Grid, GridItem,Icon  } from 'vant';
    import service from '../server'

    export default {
        name: "HomeMenu",
        components:{
            SwipeImage:SwipeImage,
            [Grid.name]:Grid,
            [GridItem.name]:GridItem,
            [Icon.name]:Icon
        },
        data(){
            return {
                iconclor:"#6685a4"
            }
        },
        methods:{
            test(){
                let param = {
                    createPersonId: "df3b4713ef314a20a91552024a96d15e",
                    ouid: "2814d49e9f0d46c3983e29fa2fbad617"
                }
                service.selSysMessageCount(param).then(res=>{
                    console.log(res);
                })
            }
        }
    }
</script>

<style scoped>
    .block{
        top:0px;
        width:100%;
        height: 100vh;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        background-color: #F3F4F8;
    }
    .item{
        font-size: 20px;
        height: 100px;
        border-radius: 10px;
    }
    .gridwarp{
        width:95%;
        margin:10px auto 0 auto;
        background: #ffffff;
        border-radius: 10px;
    }
    .griditemwarp{
        width: 90%;
        margin:auto;
        padding: 10px;
    }
    .iconwarp{
        /*width: 40%;*/
        /*float: left;*/
        /*padding-top: 4px;*/
        position: absolute;
        top:20px;
        left:20px;

    }
    .textwarp{
        position: absolute;
        top:20px;
        left:70px;
        text-align: left;
        width:100px;
        /*float: left;*/
        font-size: 15px;
        /*padding-top: 4px;*/
        /*text-align: left;*/
    }
    .subtitle{
        font-size: 14px;
        color: darkgray;
        line-height: 150%;
        margin-top: 5px;
    }
    /deep/ .van-grid-item__content{
        border-radius: 10px;
    }
</style>
